<div class="popup-main-content-container">
    <h2 *ngIf="title" class="popup-title">{{ title }}</h2>
    <div *ngIf="content" class="main-content-container">{{ content }}</div>
    <div *ngIf="tableLines && tableLines.length > 0" class="list-content-wrapper tv-custom-scroll-bar">
        <div *ngFor="let tableLine of tableLines">
            <p class="list-item">{{ tableLine }}</p>
        </div>
    </div>
    <mat-dialog-actions class="buttons-container">
        <button (click)="onButtonClick(false)" id="cancelButton" class="tv-ns-secondary-large-button-on-light-bg abandon-button">
            {{ cancelButtonTitle }}
        </button>
        <button (click)="onButtonClick(true)" id="okButton" class="tv-ns-validation-large-button">{{ okButtonTitle }}</button>
    </mat-dialog-actions>
</div>
